<div class="form-group mt-0">
    <div class="row">
        <div class="col">
            <label class="input-label">{{ 'header.swaggerurls' | translate }} ({{ urls ? urls.length : '0' }})</label>
            <div class="table-items">
                <div class="item" *ngFor="let url of urls; let i = index; let last = last;">
                    <div class="row">
                        <div class="col-5 align-items-center justify-content-start">
                            <span *ngIf="!editMode[i] || editType !== 'name'"
                              (click)="editMode[i]=true;editType='name';$event.stopPropagation();"
                              style="cursor:pointer;">{{url.name | translate}}</span>
                            <form *ngIf="editMode[i] && editType === 'name'"
                                (click)="$event.stopPropagation();"
                                style="width:100%;display:flex;align-items:center;">
                                <input class="form-control"
                                    type="text"
                                    name="name"
                                    [(ngModel)]="url.name"
                                    placeholder="{{ 'annexes.swagger_name.placeholder' | translate }}"
                                    #name="ngModel"
                                    [rangeLength]="[2, 256]"
                                    required
                                    style="padding-inline-end:45px;">
                                <i *ngIf="isLoading"
                                class="fa fa-spinner fa-spin services-select__remove services-select__icon"
                                aria-hidden="true"
                                style="position:absolute;right:20px;"></i>
                                <i *ngIf="!isLoading"
                                (click)="editUrl(url);$event.stopPropagation();"
                                class="fa fa-check btn-xs btn-outline-primary btn-icon float-right nglist-item-action remove__icon"
                                aria-hidden="true"
                                style="position:absolute;right:40px;"></i>
                                <i *ngIf="!isLoading"
                                (click)="resetEdit();$event.stopPropagation();"
                                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon"
                                aria-hidden="true"
                                style="position:absolute;right:20px;"></i>
                            </form>
                        </div>
                        <div class="col-5 align-items-center justify-content-start">
                            <span *ngIf="!editMode[i] || editType !== 'url'"
                              (click)="editMode[i]=true;editType='url';$event.stopPropagation();"
                              style="cursor:pointer;">{{url.url | translate}}</span>
                            <form *ngIf="editMode[i] && editType === 'url'"
                                (click)="$event.stopPropagation();"
                                style="width:100%;display:flex;align-items:center;">
                                <input class="form-control"
                                    type="text"
                                    name="url"
                                    [(ngModel)]="url.url"
                                    placeholder="{{ 'annexes.swagger_url.placeholder' | translate }}"
                                    #name="ngModel"
                                    [rangeLength]="[2, 256]"
                                    required
                                    style="padding-inline-end:45px;">
                                <i *ngIf="isLoading"
                                class="fa fa-spinner fa-spin services-select__remove services-select__icon"
                                aria-hidden="true"
                                style="position:absolute;right:20px;"></i>
                                <i *ngIf="!isLoading"
                                (click)="editUrl(url);$event.stopPropagation();"
                                class="fa fa-check btn-xs btn-outline-primary btn-icon float-right nglist-item-action remove__icon"
                                aria-hidden="true"
                                style="position:absolute;right:40px;"></i>
                                <i *ngIf="!isLoading"
                                (click)="resetEdit();$event.stopPropagation();"
                                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon"
                                aria-hidden="true"
                                style="position:absolute;right:20px;"></i>
                            </form>
                        </div>
                        <div class="col-1 align-items-center justify-content-end">
                            <i class="fas fa-cog btn-xs" (click)="openSettings(url)"></i>
                        </div>
                        <div class="col-1 align-items-center justify-content-end">
                            <confirmation [showTrashIcon]="true"
                                [question]="'confirm.areyousure'"
                                (isConfirmed)="removeUrl($event, url.id)"
                                style="position:relative;"></confirmation>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="row">
                        <div class="col-5 align-items-center justify-content-start">
                            <input class="form-control w-100"
                                type="text"
                                name="name"
                                [(ngModel)]="swaggerName"
                                placeholder="{{ 'annexes.swagger_name.placeholder' | translate }}"
                                #name="ngModel"
                                [rangeLength]="[1, 5]"
                                required />
                        </div>
                        <div class="col-5 align-items-center justify-content-start">
                            <input class="form-control w-100"
                                type="text"
                                name="url"
                                [(ngModel)]="url"
                                placeholder="{{ 'annexes.swagger_url.placeholder' | translate }}"
                                #name="ngModel"
                                [rangeLength]="[1, 5]"
                                required />
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                            <button class="editBtn  btn-dark {{ url && url.length >= 2 ? '' : 'block' }}"
                                (click)="addUrl();$event.stopPropagation();">{{ 'Add' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<drawer [title]="'url.settings'" [isClosed]="!settingsModalOpened" (saveEvent)="saveSettings()" (closeEvent)="closeSettings()" *ngIf="settingsData !== null">
    <div class="row drawer-content drawer-direct-content mt-4">
        <div class="col">
            <div>
                <div class="form-group mt-0">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'name' | translate }}</label>
                            <input type="text"
                                   value="{{settingsData.name}}"
                                   [(ngModel)]="settingsData.name"
                                   class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label class="input-label">{{ 'api.url' | translate }}</label>
                    <input type="text" value="{{settingsData.apiUrl}}" [(ngModel)]="settingsData.apiUrl" class="form-control">
                  </div>
                </div>
            </div>
            <fieldset>
                <legend>TLS</legend>
                <div class="form-group mt-0">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">
                                <input type="checkbox"
                                       value="{{settingsData.useTls}}"
                                       [(ngModel)]="settingsData.useTls">
                                {{ 'tls.active' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">
                                <input type="checkbox"
                                       value="{{settingsData.tlsUseXRoadComponent}}"
                                       [(ngModel)]="settingsData.tlsUseXRoadComponent">
                                {{ 'tls.using.xroad.component' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && !settingsData.tlsUseXRoadComponent">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'tls.type' | translate }}</label>
                            <select class="form-control"
                                    [(ngModel)]="settingsData.tlsType">
                                <option value=""></option>
                                <option *ngFor="let tlsType of tlsTypes" value="{{tlsType}}">
                                    {{tlsType}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && !settingsData.tlsUseXRoadComponent">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'tls.keystore.path' | translate }}</label>
                            <input type="text"
                                   value="{{settingsData.tlsKeystorePath}}"
                                   [(ngModel)]="settingsData.tlsKeystorePath"
                                   class="form-control">
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && !settingsData.tlsUseXRoadComponent">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'tls.keystore.alias' | translate }}</label>
                            <input type="text"
                                   value="{{settingsData.tlsKeystoreAlias}}"
                                   [(ngModel)]="settingsData.tlsKeystoreAlias"
                                   class="form-control">
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && !settingsData.tlsUseXRoadComponent">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">
                                <input type="checkbox"
                                       value="{{settingsData.tlsUsingPassword}}"
                                       [(ngModel)]="settingsData.tlsUsingPassword">
                                {{ 'tls.using.password' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && settingsData.tlsUsingPassword && !settingsData.tlsUseXRoadComponent">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'tls.keystore.password' | translate }}</label>
                            <input type="text"
                                   value="{{settingsData.tlsKeyPassword}}"
                                   [(ngModel)]="settingsData.tlsKeyPassword"
                                   class="form-control">
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && !settingsData.tlsUseXRoadComponent">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">
                                <input type="checkbox"
                                       value="{{settingsData.tlsUsingKeyPassword}}"
                                       [(ngModel)]="settingsData.tlsUsingKeyPassword">
                                {{ 'tls.using.key.password' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && !settingsData.tlsUseXRoadComponent">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">
                                <input type="checkbox"
                                       value="{{settingsData.tlsInsecure}}"
                                       [(ngModel)]="settingsData.tlsInsecure">
                                {{ 'tls.insecure' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">
                                <input type="checkbox"
                                       value="{{settingsData.tlsUseUxp}}"
                                       [(ngModel)]="settingsData.tlsUseUxp">
                                {{ 'tls.using.uxp.connection' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && settingsData.tlsUseUxp">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'tls.uxp.client' | translate }}</label>
                            <input type="text"
                                   value="{{settingsData.tlsUxpClient}}"
                                   [(ngModel)]="settingsData.tlsUxpClient"
                                   class="form-control">
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.useTls && settingsData.tlsUseUxp">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'tls.uxp.service' | translate }}</label>
                            <input type="text"
                                   value="{{settingsData.tlsUxpService}}"
                                   [(ngModel)]="settingsData.tlsUxpService"
                                   class="form-control">
                        </div>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <legend>{{ 'wsdl.configuration' | translate }}</legend>
                <div class="form-group mt-0">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">
                                <input type="checkbox"
                                       value="{{settingsData.wsdlGenerateCollectionItems}}"
                                       [(ngModel)]="settingsData.wsdlGenerateCollectionItems">
                                {{ 'wsdl.generateCollectionItems' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="settingsData.wsdlGenerateCollectionItems">
                    <div class="row">
                        <div class="col-12">
                            <label class="input-label">{{ 'wsdl.itemsInCollection' | translate }}</label>
                            <input type="number"
                                   value="{{settingsData.wsdlItemsInCollection}}"
                                   [(ngModel)]="settingsData.wsdlItemsInCollection"
                                   class="form-control">
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</drawer>

